export const strongMap = <T extends string | number | symbol, U>(map: Record<T, U>, type: T) => {
  return map[type] || ({} as U);
};
